module.exports = __webpack_public_path__ + "static/assets/238a12e6d066c100697e7b28c87913d0.svg";